
import React, { useState, useEffect } from 'react';
// import { SmileOutlined,DeleteOutlined } from '@ant-design/icons';
import {
  // ProForm,
  EditableProTable,
} from '@ant-design/pro-components';
import { Form, message } from 'antd';
import "./tmp.css"
import moment from 'moment';

const waitTime = (time) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

export default (props) => {
  const {editForm, label, name, initdata, worktime, started} = props;
  const [editableKeys, setEditableRowKeys] = useState([]);
  const [hasWeekend, setHasWeekend] = useState("");
  // const [editableKeys, setEditableRowKeys] = useState(() =>
  //   defaultData.map((item) => item.id),
  // );
  const [initKedys, setInitKedys] = useState([]);

  useEffect(() => {
    console.log('initdata - ', initdata)
    if(initdata){
      setEditableRowKeys(() =>
        initdata.map((item) => item.id)
      );
      setInitKedys(() =>
        initdata.map((item) => item.id)
      );
    }

  }, [initdata]);

  useEffect(() => {
    console.log('editableKeys - ', editableKeys)

  }, [editableKeys]);
  
  const columns = {
    "client_list" :[
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
      // width: '40%',
      formItemProps: {
        rules: [
          {
            required: true,
            whitespace: true,
            message: '姓名不能为空',
          },
        ],
      },
    },
    {
      title: '手机号码',
      dataIndex: 'phone',
      key: 'phone',
      // width: '40%',
      formItemProps: {
        rules: [
          {
            required: true,
            whitespace: true,
            message: '手机号码不能为空',
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入有效的手机号码',
          },
        ],
      },
    },
    {
      title: '邮箱',
      dataIndex: 'email',
      key: 'email',
      // width: '40%',
      formItemProps: {
        rules: [
          {
            required: true,
            whitespace: true,
            message: '邮箱不能为空',
          },
          {
            type: 'email',
            message: '请输入有效的邮箱地址',
          },
        ],
      },
    },
    {
      title: '',
      valueType: 'option',
      key: 'option',
      width: 50,
    },
  ],
  "avl_intv_time":[
    {
      title: null,
      dataIndex: 'atime',
      key: 'atime',
      valueType: 'dateTimeRange',
      fieldProps: {
        showTime:{ format: 'HH:mm' },
        format:"YYYY-MM-DD HH:mm",
        // defaultValue={defaultTimeRange}
        placeholder:['开始时间', '结束时间'],
        disabledDate: (current) => {
          return current && current < moment().startOf('day');
        },
        disabledTime: (current, type) => {
          const now = moment();
          if (!current || current.isSame(now, 'day')) {
            return {
                disabledHours: () => {
                    const hours = [];
                    for (let i = 0; i < now.hours(); i++) {
                        hours.push(i);
                    }
                    return hours;
                },
                disabledMinutes: (selectedHour) => {
                    if (selectedHour==-1 || selectedHour === now.hours()) {
                        const minutes = [];
                        for (let i = 0; i < now.minutes(); i++) {
                            minutes.push(i);
                        }
                        return minutes;
                    }
                    return [];
                },
                disabledSeconds: () => [],
            };
          }
          return {
              disabledHours: () => [],
              disabledMinutes: () => [],
              disabledSeconds: () => [],
          };
        },
      },
      // formItemProps: {
      //   rules: [
      //     {
      //       required: true,
      //       whitespace: true,
      //       message: '请选择时间段',
      //     },
      //   ],
      // },
      // width: '40%',
      // formItemProps: {
      //   rules: [
      //     {
      //       required: true,
      //       whitespace: true,
      //       message: '姓名不能为空',
      //     },
      //   ],
      // },
    },
    {
      title: '',
      valueType: 'option',
      key: 'option',
      width: 50,
    },
  ]
  };
    
  const isWeekend = (date) => {
    const day = moment(date).day();
    return day === 0 || day === 6;
  };

  const checkTimeRangeForWeekend = (timeRange) => {
    console.log(timeRange)
      if (!timeRange || timeRange.length!== 2) return false;
      const start = moment(timeRange[0]);
      const end = moment(timeRange[1]);
      console.log(start,end)
      let current = start.clone();
      console.log(current)
      while (current.isSameOrBefore(end, 'day')) {
          if (isWeekend(current)) {
              return true;
          }
          current.add(1, 'day');
      }
      return false;
  };
  
  const handleChange = (value) => {
    const containsWeekend = checkTimeRangeForWeekend(value);
    if(containsWeekend)
      setHasWeekend(<div style={{color:'red',fontSize:'12px',lineHeight: '20px',paddingTop:10,width:"100%",textAlign:"left"}}>您设的时间段包含周末，如果周末休息可用拆分为多个工作日时段</div>);
    else
      setHasWeekend("");
  };

  return (

          <Form.Item
            label={label}
            name={name}
            // initialValue={defaultData}
            trigger="onValuesChange"
            extra={name=='avl_intv_time'?<div style={{color:'green',fontSize:'12px',lineHeight: '20px',paddingTop:10,width:"100%",textAlign:"left"}}>*时间段须按由近到远递增原则设置<br/>*若所设时间段开始时间早于上班时间或结束时间晚于下班时间，则所设时间段内包含的工作日时间按照所设时间段进行</div>:""}
            // validateStatus="error"
            help={hasWeekend}
            // style={{
            //   paddingTop:20,
            //   paddingBottom:20,
            //   marginTop: 50,
            //   marginBottom: 20,
            //   // backgroundColor:"rgb(246,246,247)"
            // }}
          >
            <EditableProTable
              rowKey="id"
              className='client_list'
              toolBarRender={false}
              columns={columns[name]}
              showHeader={name=='avl_intv_time'?false:true}
              recordCreatorProps={{
                newRecordType: 'dataSource',
                position: "bottom",
                creatorButtonText: '添加'+label,
                record: () => ({
                  id: Date.now(),
                  // addonBefore: 'ccccccc',
                  // decs: 'testdesc',
                }),
              }}
              editable={{
                type: 'multiple',
                form: editForm,
                editableKeys: editableKeys,
                onChange: setEditableRowKeys,
                actionRender: (row, _, dom) => {
                  console.log('editable - ', row, initKedys)
                  // console.log(_)
                  // console.log(dom)
                  if(started=='1' && initKedys.includes(row.id))
                    return [];
                  else
                    return [dom.delete];
                },
                onSave: async (rowKey, data, row) => {
                  // console.log(rowKey, data, row);
                  await waitTime(100);
                },
      
              }}
              onValuesChange={(changedValues) => {
                console.log(changedValues)
                if(name == 'avl_intv_time'){
                  for(let t of changedValues){
                    if (t.atime && !hasWeekend) {
                        handleChange(t.atime);
                    }
                    if(t.atime[0].substring(t.atime[0].length - 5)<worktime[0] || t.atime[1].substring(t.atime[1].length - 5)>worktime[1])
                      message.warning("您所设的时间段中存在早于或晚于上下班时间的情况，请注意设置规则")
                  }
                }
              }}
            />
          </Form.Item>

  );
};